export default __webpack_public_path__ + "static/media/AGLeventis_Logo.c03608d9.jpg";